import { render, staticRenderFns } from "./setting-exam.vue?vue&type=template&id=5f236760&scoped=true&"
import script from "./setting-exam.vue?vue&type=script&lang=js&"
export * from "./setting-exam.vue?vue&type=script&lang=js&"
import style0 from "./setting-exam.vue?vue&type=style&index=0&id=5f236760&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f236760",
  null
  
)

export default component.exports